import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { getColorway, getSectionProps } from 'utils/styles';
import { LaunchpadProps } from './types';
import Button from 'components/shared/Buttons/BaseButton';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const Launchpad = ({ sys, headline, copy, cta, outerColor, innerColor, sectionName, margins }: LaunchpadProps) => {
  return (
    <section {...getSectionProps(outerColor, margins, sectionName)}>
      <div className="content-wrapper">
        <div className={`${getColorway(innerColor)} rounded-md p-8 md:px-12 lg:px-20`}>
          <div className="flex flex-col sm:flex-row justify-between gap-6">
            <div className="sm:basis-3/4 flex flex-col sm:flex-row gap-6">
              {headline && (
                <div
                  className="sm:basis-1/2 text-heading-md md:text-heading-lg font-sans font-semibold"
                  {...liveUpdateAttrs(sys?.id, 'headline')}>
                  <RichTextHeadline headline={headline} />
                </div>
              )}
              {copy && (
                <div className="sm:basis-1/2 font-serif text-body-serif" {...liveUpdateAttrs(sys?.id, 'copy')}>
                  <RichTextCopy copy={copy} />
                </div>
              )}
            </div>
            <div {...liveUpdateAttrs(sys?.id, 'cta')}>
              {cta && (
                <Button
                  sys={cta?.sys}
                  href={cta.url}
                  internalPage={cta?.internalPage}
                  className="md:max-w-none lg:w-[150px]">
                  {cta.text}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Launchpad;
